import { insertAfter, insertBefore } from 'helpers/dom-helper';
import ApplicationController from './application_controller';
import log from '../lib/logger';

/**
 * Renders template tag's children element into the DOM.
 *
 * @example
 * <div
 *   data-controller="render-template"
 *   data-render-template-action-value="after"
 *   data-render-template-times-value="2"
 *   data-action="click->render-template#render"
 * >
 *   <template data-render-template-target="template">
 *     // some content
 *   </template>
 * </div>
 */

export default class extends ApplicationController {
  templateIdentifier = 'data-render-template-identifier';

  static targets = ['template'];
  static values = {
    action: {
      type: String,
      default: 'update',
    },
    times: {
      type: Number,
      default: Infinity,
    },
  };

  initialize() {
    if (this.isTurbolinksPreview || !this.hasTemplateTarget) return;

    if (this.templateContent.childElementCount > 1) {
      log.error('Render template can only have 1 immediate child element');
    }
  }

  render() {
    if (this.existingElements.length === this.timesValue) return;

    const contentChild = this.templateContent.firstElementChild;
    if (!contentChild) return;

    contentChild.setAttribute(this.templateIdentifier, '');
    this.insertTemplateContent(contentChild);
  }

  // Private

  insertTemplateContent(content) {
    switch (this.actionValue) {
      case 'after':
        insertAfter(content, this.element);
        break;
      case 'append':
        this.element.append(content);
        break;
      case 'before':
        insertBefore(content, this.element);
        break;
      case 'prepend':
        this.element.prepend(content);
        break;
      case 'replace':
        this.element.replaceWith(content);
        break;
      case 'update':
        this.element.replaceChildren(content);
        break;
      default:
        log.error(`Undefined action value: ${this.actionValue}`);
        break;
    }
  }

  get templateContent() {
    return this.templateTarget.content.cloneNode(true);
  }

  get existingElements() {
    return document.querySelectorAll(`[${this.templateIdentifier}]`);
  }
}
